function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module alignment/alignmentediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AlignmentCommand from './alignmentcommand';
import { isDefault, isSupported, supportedOptions } from './utils';
/**
 * The alignment editing feature. It introduces the {@link module:alignment/alignmentcommand~AlignmentCommand command} and adds
 * the `alignment` attribute for block elements in the {@link module:engine/model/model~Model model}.
 * @extends module:core/plugin~Plugin
 */

var AlignmentEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(AlignmentEditing, _Plugin);

  _createClass(AlignmentEditing, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'AlignmentEditing';
    }
    /**
     * @inheritDoc
     */

  }]);

  function AlignmentEditing(editor) {
    var _this;

    _classCallCheck(this, AlignmentEditing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlignmentEditing).call(this, editor));
    editor.config.define('alignment', {
      options: _toConsumableArray(supportedOptions)
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AlignmentEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var locale = editor.locale;
      var schema = editor.model.schema; // Filter out unsupported options.

      var enabledOptions = editor.config.get('alignment.options').filter(isSupported); // Allow alignment attribute on all blocks.

      schema.extend('$block', {
        allowAttributes: 'alignment'
      });
      editor.model.schema.setAttributeProperties('alignment', {
        isFormatting: true
      });

      var definition = _buildDefinition(enabledOptions.filter(function (option) {
        return !isDefault(option, locale);
      }));

      editor.conversion.attributeToAttribute(definition);
      editor.commands.add('alignment', new AlignmentCommand(editor));
    }
  }]);

  return AlignmentEditing;
}(Plugin); // Utility function responsible for building converter definition.
// @private


export { AlignmentEditing as default };

function _buildDefinition(options) {
  var definition = {
    model: {
      key: 'alignment',
      values: options.slice()
    },
    view: {}
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var option = _step.value;
      definition.view[option] = {
        key: 'style',
        value: {
          'text-align': option
        }
      };
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return definition;
}